<script setup lang="ts">

</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      id="cross_circle_2_path_1"
      d="M29.3346 16C29.3346 8.6362 23.365 2.66667 16.0013 2.66667C8.6375 2.66667 2.66797 8.6362 2.66797 16C2.66797 23.3637 8.6375 29.3333 16.0013 29.3333C23.365 29.3333 29.3346 23.3637 29.3346 16Z"
      fill="#010100"
      stroke="currentColor"
      stroke-width="2.66667"
    />
    <path
      d="M19.9992 20L12 12M12.0009 20L20 12"
      stroke="white"
      stroke-width="2.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped>

</style>